import { render, staticRenderFns } from "./AllGoods.vue?vue&type=template&id=4d137759&scoped=true"
import script from "./AllGoods.vue?vue&type=script&lang=js"
export * from "./AllGoods.vue?vue&type=script&lang=js"
import style0 from "./AllGoods.vue?vue&type=style&index=0&id=4d137759&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d137759",
  null
  
)

export default component.exports